// 素材
export default [
  {
    path: '/ue',
    redirect: '/ue/model',
  },

  // 模型
  {
    path: '/ue/model',
    name: 'ue-ueitem',
    component: () => import(/* webpackChunkName: "ue" */ '@/views/ue/ueitem/Index.vue'),
    meta: { title: '模型管理' },
  },
  {
    path: '/ue/model/actor/edit/:fullpath',
    name: 'ue-ueitem-actor-edit',
    component: () => import(/* webpackChunkName: "ue" */ '@/views/ue/ueitem/edit/Actor.vue'),
    meta: { title: '模型管理' },
  },
  {
    path: '/ue/model/mesh/edit/:fullpath',
    name: 'ue-ueitem-mesh-edit',
    component: () => import(/* webpackChunkName: "ue" */ '@/views/ue/ueitem/edit/Mesh.vue'),
    meta: { title: '模型管理' },
  },
  {
    path: '/ue/model/obj/edit/:fullpath',
    name: 'ue-ueitem-obj-edit',
    component: () => import(/* webpackChunkName: "ue" */ '@/views/ue/ueitem/edit/Obj.vue'),
    meta: { title: '模型管理' },
  },

  // 型材
  {
    path: '/ue/section-bar',
    name: 'ue-section-bar',
    component: () => import(/* webpackChunkName: "ue" */ '@/views/ue/section-bar/Index.vue'),
    meta: { title: '型材管理' },
  },
  // {
  //   path: '/ue/section-bar/add',
  //   name: 'ue-section-bar-add',
  //   component: () => import(/* webpackChunkName: "ue" */ '@/views/ue/section-bar/add/Index.vue'),
  //   meta: { title: '型材管理' },
  // },
  // {
  //   path: '/ue/section-bar/edit/:code',
  //   name: 'ue-section-bar-edit',
  //   component: () => import(/* webpackChunkName: "ue" */ '@/views/ue/section-bar/edit/Index.vue'),
  //   meta: { title: '型材管理' },
  // },
  // {
  //   path: '/ue/section-bar/detail/:code',
  //   name: 'ue-section-bar-detail',
  //   component: () => import(/* webpackChunkName: "ue" */ '@/views/ue/section-bar/detail/Index.vue'),
  //   meta: { title: '型材管理' },
  // },

  // 材质
  {
    path: '/ue/instance',
    name: 'ue-instance',
    component: () => import(/* webpackChunkName: "ue" */ '@/views/ue/instance/Index.vue'),
    meta: { title: '材质管理' },
  },

  // 贴图包
  {
    path: '/ue/texture',
    name: 'ue-texture',
    component: () => import(/* webpackChunkName: "ue" */ '@/views/ue/texture/Index.vue'),
    meta: { title: '贴图包管理' },
  },
  {
    path: '/ue/texture/check',
    name: 'ue-texture-check',
    component: () => import(/* webpackChunkName: "ue" */ '@/views/ue/texture/Check.vue'),
    meta: { title: '贴图包管理' },
  },
];
